import Matter from 'matter-js'
import Consts from './MatterConsts'

const Common = (Matter as any).Common

export default class MatterTapi {
  private balls: Matter.Composite

  constructor(world: Matter.World) {

    const balls = this.balls = Matter.Composites.stack(
      290, -700, 2, 15, 7, 7, (x, y) => 
      Matter.Bodies.circle(
        x + Common.random(5, 15), 
        y + Common.random(5,  20), 
        Common.random(15,  16), 
        {
          friction: 0.8,
          restitution: Common.random(0.3,  0.55),
          density: 0.003,
          collisionFilter: {
            group: 0,
            category: Math.random() < 0.1 ? Consts.CAT_TAPI : Consts.CAT_TEA,
            mask: -1
          }
        }
      )
    )
    balls.bodies.forEach(b => b.sleepThreshold = 2000)
    Matter.World.add(world, balls)
  }

  public get points(): Matter.Vector[] {
    return this.balls.bodies.map(b => b.position)
  }
}
